import React from 'react';
import { motion } from 'framer-motion';
import { ProductCard } from './ProductCard';

const products = [
  {
    name: "Jade Roller & Gua Sha Set",
    description: "Ancient beauty tools for facial massage and lymphatic drainage.",
    image: "https://customer-assets.emergentagent.com/job_shine-beauty/artifacts/7o0fa5f0_Jade%20Roller%20%26%20Gua%20Sha%20Set.png",
  },
  {
    name: "Ice Globes Cryo Facial Massager",
    description: "Cryotherapy balls for de-puffing and soothing skin.",
    image: "https://customer-assets.emergentagent.com/job_shine-beauty/artifacts/fgqudvkj_ice%20globes%20cryo%20facial%20massager.png",
  },
  {
    name: "Silk Pillow Cover - Yellow",
    description: "Wake up to smoother skin and healthier hair with pure mulberry silk.",
    image: "https://customer-assets.emergentagent.com/job_shine-beauty/artifacts/il6pzgj8_Silk%20Pillow%20Cover%20Yellow.png",
  },
  {
    name: "Silk Pillow Cover - White",
    description: "Luxurious silk pillowcase for beauty sleep and hair care.",
    image: "https://customer-assets.emergentagent.com/job_shine-beauty/artifacts/h3ew0nhi_Silk%20Pillow%20Cover%20White.png",
  },
  {
    name: "Silk Hair Bonnet - Cream",
    description: "Protect your hair while you sleep with soft, breathable silk.",
    image: "https://customer-assets.emergentagent.com/job_shine-beauty/artifacts/815f73g2_Silk%20Hair%20Bonnet%20Cream.png",
  },
  {
    name: "Silk Hair Bonnet - Caramel",
    description: "Premium silk bonnet to reduce frizz and maintain hairstyles.",
    image: "https://customer-assets.emergentagent.com/job_shine-beauty/artifacts/jbrldyyp_Silk%20Hair%20Bonnet%20Caramel.png",
  },
  {
    name: "Red Light Face Massager",
    description: "Rejuvenating red light technology for skin renewal and scalp care.",
    image: "https://customer-assets.emergentagent.com/job_shine-beauty/artifacts/y6ji6vi6_Red%20Light%20Face%20Massager.png",
  },
  {
    name: "Wireless Eye Massager",
    description: "Heat therapy with built-in Bluetooth music for relaxation.",
    image: "https://customer-assets.emergentagent.com/job_shine-beauty/artifacts/2el68y0u_Wireless%20Eye%20Massager%20with%20Heat%20and%20Built-in%20Bluetooth%20Music.png",
  },
  {
    name: "Brown Silicone Facial Cleanser",
    description: "Gentle yet effective deep pore cleansing with soft silicone bristles.",
    image: "https://customer-assets.emergentagent.com/job_shine-beauty/artifacts/4v2le3f3_Brown%20Silicone%20Facial%20Cleanser.png",
  },
  {
    name: "Yellow Silicone Facial Cleanser",
    description: "Premium silicone facial brush for a radiant, clear complexion.",
    image: "https://customer-assets.emergentagent.com/job_shine-beauty/artifacts/qx1usoz5_Yellow%20Silicone%20Faci%20Cleanser.png",
  },
  {
    name: "Seashell Phototherapy Massage Pillow",
    description: "Red light therapy with soothing massage for neck and waist relief.",
    image: "https://customer-assets.emergentagent.com/job_shine-beauty/artifacts/p9uf6j4g_Red%20Seashell%20Phototherapy%20Massage%20Pillow%20and%20Waist%20Massager.png",
  },
];

export const Products = () => {
  return (
    <section id="products" data-testid="products-section" className="py-24 lg:py-32 relative">
      {/* Background blob */}
      <div className="blob-container">
        <div className="golden-blob blob w-[500px] h-[500px] top-0 right-[-200px] opacity-50" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-[#DAB668] text-sm font-medium tracking-widest uppercase mb-4 block">
            Our Collection
          </span>
          <h2 data-testid="products-heading" className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#2C2C2C] mb-6">
            Premium Beauty Tools
          </h2>
          <p className="text-[#6E6A62] max-w-2xl mx-auto">
            Curated wellness essentials designed for your daily self-care ritual.
          </p>
        </motion.div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {products.map((product, index) => (
            <ProductCard key={product.name} product={product} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
